/* External dependencies */
import gql from 'graphql-tag';

export const getServiceQuery = gql`
  query getService($input: GetServiceInput!) {
    getService(input: $input) {
      exactAmountRequired
      preferences {
        fieldId
      }
      logo {
        url
      }
      rboCode
      name_en
      name_ru
      name_ky
      name_tr
      placeholder_en
      placeholder_ky
      placeholder_ru
      placeholder_tr
      minAmount {
        currency
        amount
      }
      maxAmount {
        currency
        amount
      }
      maxDigits
      minDigits
      status
      statusMessage
      id
      tags
      requiredFieldsServiceId
      requiredFieldsProvider
      serviceProviders {
        serviceId
        serviceProviderId
        currency
        minAmount {
          amount
          currency
        }
        maxAmount {
          amount
          currency
        }
        clientFees {
          distribution {
            distribution
            dynamicDistributionSteps {
              from {
                amount
                currency
              }
              distribution {
                distribution
                flatDistribution {
                  amount
                  currency
                }
              }
            }
            flatDistribution {
              amount
              currency
            }
          }
          fees {
            flatFee {
              amount
              currency
            }
            flatFeePercent
            dynamicFeeSteps {
              from {
                amount
                currency
              }
              fee {
                flatFee {
                  amount
                  currency
                }
                flatFeePercent
              }
            }
          }
        }
        requiredFieldsMapping {
          name
          value
        }
        serviceRewardFees {
          distribution {
            distribution
            dynamicDistributionSteps {
              from {
                amount
                currency
              }
              distribution {
                distribution
                flatDistribution {
                  amount
                  currency
                }
              }
            }
            flatDistribution {
              amount
              currency
            }
          }
          fees {
            flatFee {
              amount
              currency
            }
            flatFeePercent
            dynamicFeeSteps {
              from {
                amount
                currency
              }
              fee {
                flatFee {
                  amount
                  currency
                }
                flatFeePercent
              }
            }
          }
        }
      }
    }
  }
`;
